import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "Is this an official police report?",
  answer: "We provide access to official accident reports filed by local and state law enforcement agencies. Our service simplifies the retrieval process so you can get the documentation you need for insurance or legal purposes quickly and efficiently."
}, {
  question: "How is my personal data protected?",
  answer: "Your privacy is our highest priority. We use industry-standard encryption to protect your information and only share it with authorized sponsors who help facilitate your request, as clearly outlined in our terms of use."
}, {
  question: "How long does it take to receive my report?",
  answer: "Most reports are located and processed within 24 to 48 hours. However, the exact timing depends on the specific law enforcement agency's processing speed and the date of the accident occurrence."
}, {
  question: "Is there a fee for using Crash Report Finder?",
  answer: "Our search service is supported by our partners, allowing us to help you locate your report. In many cases, we can provide guidance on obtaining your report at no direct cost to you through these legal and insurance sponsorships."
}, {
  question: "What if my accident report isn't found immediately?",
  answer: "If we cannot immediately locate your report, our team will perform a manual review. Some reports take longer to be uploaded to official databases, and we will notify you as soon as your specific record becomes available."
}];
export default function CommonTechInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}